var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"history"},_vm._l((_vm.tournaments),function(tournament,t){return _c('div',{key:t,staticClass:"wrapper"},[_c('tournament-history',{attrs:{"tournament":tournament,"show-time":_vm.showTime}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }